import TransitionWrapper from 'global/wrappers/TransitionWrapper'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import React, { useContext, useState } from 'react'
import SportFormProps from './SportFormProps'
import { _sportsFormProps } from '../cnr/contexts/SportsSeasonContext'
import { _sdm } from '../elements/dashboard/SportsDashboard'
import { Form } from 'semantic-ui-react'
import UiSaveButtons from 'global/components/buttons/UiSaveButtons'
import { useSportsAccess } from '../useHelpers/useSportsAccess'
import { SportsDistrictContext } from '../cnr/contexts/SportsDistrictContext'
import { ParentContext } from 'global/cnr/contexts/ParentContext'

const TeamLinks = ({ currentTeam }) => {

  const { _itemKey } = currentTeam ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { teams: teamKey } = pathViews ?? {}

  const _teamKey = _itemKey || teamKey

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data } = sportsDistrict_state ?? {}
  const { teamsInfo } = district_data ?? {}
  const _teamInfo = teamsInfo?.[_teamKey] || {}

  console.log('_teamKey', _teamKey, _teamInfo)

  const _baseInfo = _sportsFormProps[_sdm.sports.teamLinks]

  const { updating: updating_access, updateTeamInfo } = useSportsAccess()

  const [formData_teamLinks, setFormData_teamLinks] = useState(_.merge({}, _baseInfo, _teamInfo))

  const [teamInfo, setTeamInfo] = useState(formData_teamLinks)

  const handleFormChange = (e, data) => {
    setTeamInfo(prev => ({
      ...prev,
      [data.propname]: data.value
    }))
  }

  const handle_update = () => {
    updateTeamInfo({ teamKey: _teamKey, teamInfo })
    console.log('currentFormData', teamInfo)
  }

  const formElements_teamLinks = () => {
    const inputs = []
    if (formData_teamLinks) {
      return <SportFormProps
        formData={teamInfo}
        handleFormChange={handleFormChange}
      />
    }
    return inputs
  }

  const content_form_teamLinks = () => <Form>
    {formElements_teamLinks()}
  </Form>

  const footer_item = () => <UiSaveButtons save={{ oc: handle_update, caption: 'Save GLS' }} />

  const wrapper_teamLinks = () => <TransitionWrapper>
    <Wrapper
      content={content_form_teamLinks()}
      wrapperType={wrapperTypes.padded}
      footer={footer_item()}
    >
    </Wrapper>
  </TransitionWrapper>

  return wrapper_teamLinks()

}

export default TeamLinks